<template>
    <div class="headerMindset">
      <h1 class="list-title">{{ $t('mindset.label.listMindsets.title') }}</h1>

      <v-data-table
        :search="searchTerm"
        v-model="selected"
        :headers="headers"
        :items="mindsets"
        item-key="tituloBienvenida"
        show-select
        @item-selected="handleItemSelection"
        :no-data-text="$t('chart.label.notData') || 'No hay datos disponibles'"
        :footer-props="{ 'items-per-page-text': $t('label.rowsPerPage.title') }"
      >
        <!-- Sección superior de la tabla -->
        <template v-slot:top>
          <div style="margin-bottom: 50px">
            <div class="row justify-space-between mx-auto">
              <v-text-field
                :label="$t('label.search.title')"
                :placeholder="$t('label.search.text')"
                append-icon="mdi-magnify"
                dense
                outlined
                class="col-md-5"
                @input="search"
              ></v-text-field>

              <div class="btn">
                <addMindset />
              </div>
            </div>
          </div>
        </template>

        <template v-slot:header.data-table-select>
          <span></span>
        </template>

        <template v-slot:[`item.tituloBienvenida`]="{ item }">
          <span class="custom-font">{{ item.tituloBienvenida }}</span>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <div class="actions">
            <detailsMindset :mindsetProps="item" />

            <v-btn
              icon
              small
              @click="deleteMindset(item.idImagenEmpresa)"
            >
              <v-icon color="primary">mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </div>
  </template>
  
  <script>
  import detailsMindset from "@/views/mindset/pages/detail_mindset/detail_mindset_page.vue";
  import addMindset from "@/views/mindset/pages/add_mindset/add_mindset_page.vue";
  import { mapActions, mapGetters } from "vuex";
  import i18n from '@/plugins/i18n';
  import Swal from "sweetalert2";
  
  import {
    MINDSET_M,
    GET_MINDSETS,
    ACTION_GET_LIST_MINDSETS,
    ACTION_DELETE_MINDSET,
    ACTION_PUT_UPDATE_MINDSET,
  } from "@/views/mindset/store/types/types.js";
  
  export default {
    name: "listMindsetComponent",
    components: {
      addMindset,
      detailsMindset
    },
  
    data() {
      return {
        searchTerm: "",
        selected: [],
      };
    },
  
    async mounted() {
      await this.getActionMindsets();
    },
    watch: {
      mindsets: {
        handler(newMindsets) {
          if (newMindsets && newMindsets.length > 0) {
            this.selected = newMindsets.filter(item => item.estado === true);
          }
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
  
      ...mapActions({
        getActionMindsets: `${MINDSET_M}${ACTION_GET_LIST_MINDSETS}`,
        deleteActionMindset: `${MINDSET_M}${ACTION_DELETE_MINDSET}`,
        updateActionMindset: `${MINDSET_M}${ACTION_PUT_UPDATE_MINDSET}`,
      }),

      handleItemSelection({ item, value }) {
        item.estado = value;
        this.updateActionMindset(item);
      },

      search() {
        // Actualiza el término de búsqueda
        this.searchTerm = event.target.value;
      },
  
      async deleteMindset(id) {
          const result = await Swal.fire({
            title: i18n.t('label.delete.title'),
            text: i18n.t('label.delete.text'),
            icon: "question",
            showCancelButton: true,
            confirmButtonText: i18n.t('button.delete.accept'),
            cancelButtonText: i18n.t('button.delete.cancel'),
            confirmButtonColor: "#6E17A5"
          });
  
          if (result.isConfirmed) {
            await this.deleteActionMindset(id);
            await this.getActionMindsets();
          } else {
            Swal.fire({
              position: 'top-end',
              icon: 'info',
              title: i18n.t('label.delete.cancel'),
              showConfirmButton: false,
              timer: 2500
            }); 
          }
      },
  
    },
  
    computed: {
  
      ...mapGetters({
        mindsets: [`${MINDSET_M}${GET_MINDSETS}`],
      }),
  
      headers() {
        return [
          {
            text: this.$t('mindset.label.table.title'),
            value: "tituloBienvenida",
            sortable: false,
            align: "center",
            class: "primary--text custom-header font-weight-medium text-subtitle-1",
          },
          {
            text: this.$t('mindset.label.table.actions'),
            value: "action",
            sortable: false,
            align: "center",
            width: "180",
            class: "primary--text custom-header font-weight-medium text-subtitle-1",
          },
        ];
      }, 
    },
    
  };
  </script>
  
  <style lang="css" scoped>
    .headerMindset h1,
    .list-title {
      margin-bottom: 30px;
      color: #6E17A5;
    }

    .headerMindset >>> tbody tr.v-data-table__selected {
      background: #F4EAFC !important;
    }

    .headerMindset {
      display: flex;
      gap: 40px;
      flex-direction: column;
      margin-top: 20px;
      margin-left: 20px;
    }

    .actions {
      display: flex;
      justify-content: center;
      gap: 12px;
    }

    .actions >>> .v-btn {
      height: 38px !important;
      width: 38px !important;
      min-width: 38px !important;
      border-radius: 12px !important;
      background: #FAFAFE !important;
      border: 2px solid #E9EAF3 !important;
      transition: background 0.18s ease, transform 0.18s ease, border-color 0.18s ease !important;
    }

    .actions >>> .v-btn:not(.v-btn--disabled):hover {
      background: #F4EAFC !important;
      border-color: #D9C6EE !important;
      transform: translateY(-2px);
    }

    .custom-font {
      font-size: 17px;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-family: "Amsi Pro", sans-serif;
      color: #6E17A5;
      font-weight: normal;
    }
  </style>
  